import { render, staticRenderFns } from "./logMenuHeader.vue?vue&type=template&id=32a3539a"
import script from "./logMenuHeader.vue?vue&type=script&lang=js"
export * from "./logMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./logMenuHeader.vue?vue&type=style&index=0&id=32a3539a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports